(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var MOBILE_BP = 749;
    var detailsList = document.querySelectorAll('.bobafashion-footer__details');
    if (!detailsList.length) return;

    function applyState() {
      var isMobile = window.innerWidth <= MOBILE_BP;
      detailsList.forEach(function(d) {
        if (isMobile) {
          d.removeAttribute('open');
        } else {
          d.setAttribute('open', '');
        }
      });
    }

    applyState();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyState, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
